import { createContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import { isAdminUser } from "./config/admins";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null); // ⬅️ neues State

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      setUser(user);
      if (user) {
        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setProfile(docSnap.data()); // 🎯 Profil laden
        } else {
          setProfile(null);
        }
      } else {
        setProfile(null);
      }
    });

    return () => unsub();
  }, []);

  // Admin is a permission, not a user type: recognized via the profile's
  // admin flag OR the email allowlist (so existing accounts still work).
  const isAdmin = isAdminUser(user) || isAdminUser(profile);

  return (
    <AuthContext.Provider value={{ user, profile, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}